import { SpeakerFaceCoordinatesResponse } from '@goldcast/api/content';
import { ContentMetadataStoreFactoryType } from '../stores/contentMetadataStoreFactory';
import type { Clip } from '../types/clip-types';
import { doesClipHavePlayerConfig } from './clipUtils';
import { getLayoutAvailabilityStatusPure } from './getLayoutAvailabilityStatusPure';
import { updateClipDefaultProperties } from './updateClipDefaultProperties';

export const finalizeClip = ({
  clip,
  clipConfigUpdateOverride,
  facialRecognitionToDefaultPosition,
  isSplitsTranslationEnabled,
  isFullFaceRecEnabled,
  areLayoutsEnabledForPreRecordedEvents,
  contentMetadataStoreInstance
}: {
  clip: Clip;
  clipConfigUpdateOverride?: boolean;
  facialRecognitionToDefaultPosition?: SpeakerFaceCoordinatesResponse;
  isSplitsTranslationEnabled: boolean;
  isFullFaceRecEnabled: boolean;
  areLayoutsEnabledForPreRecordedEvents: boolean;
  contentMetadataStoreInstance: ContentMetadataStoreFactoryType;
}) => {
  updateClipDefaultProperties({
    clip,
    facialRecognitionToDefaultPosition,
    isSplitsTranslationEnabled,
    isFullFaceRecEnabled,
    areLayoutsEnabledForPreRecordedEvents,
    contentMetadataStoreInstance
  });
  const layoutStatus = getLayoutAvailabilityStatusPure({
    clipLayout: clip.asset_metadata.layout,
    layoutStatus: clip.layout_status,
    clip,
    useNewPlayer: false,
    isFullFaceRecEnabled,
    areLayoutsEnabledForPreRecordedEvents
  });
  const isLayoutProcessing = layoutStatus === 'PROCESSING';
  const isLayoutUpdateRequired = isLayoutProcessing !== !!clip.asset_metadata.isLayoutProcessing;
  const doesClipNeedConfigUpdate =
    clipConfigUpdateOverride || !doesClipHavePlayerConfig(clip) || isLayoutUpdateRequired;
  if (isLayoutUpdateRequired) {
    clip.asset_metadata.isLayoutProcessing = isLayoutProcessing;
  }
  return { updateInDb: doesClipNeedConfigUpdate };
};
